import { render, staticRenderFns } from "./EventsBadges.vue?vue&type=template&id=371de7b0&"
import script from "./EventsBadges.vue?vue&type=script&lang=js&"
export * from "./EventsBadges.vue?vue&type=script&lang=js&"
import style0 from "./EventsBadges.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports